import React from 'react'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'

const BaseModalAuto = ({ isOpen, onClose, title, childComponent, size, fullscreen = false, container }) => {
    const backdropStyle = 'static';
    return (
        <Modal
            isOpen={isOpen}
            backdrop={backdropStyle}
            keyboard={false}
            zIndex={9999}
            size={fullscreen ? undefined : size || ''}
            fullscreen={fullscreen}
            container={container}
        >
            <ModalHeader toggle={onClose} >{title}</ModalHeader>
            <ModalBody style={{ paddingTop: 10 }}>
                {childComponent}
            </ModalBody>
        </Modal>
    )
}

export default BaseModalAuto
